module.exports = __webpack_public_path__ + "static/digitwin-aa0380b5d72adc2c6a5c8d57f8a23911.jpg";